module.exports = {
	quasimoda: 'quasimoda, sans-serif',
	ivyMode: 'ivymode, sans-serif',
};
